module.exports = __webpack_public_path__ + "img/pn.3f234160.svg";